import { Injectable } from "@angular/core";
import { URLS } from '../../../config/api.config';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { HTTP } from "@awesome-cordova-plugins/http/ngx";
import { Platform } from "@ionic/angular";
import { environment } from "../../../environments/environment";
import { CommonService } from "../../helpers/common.service";
import { CustomEncryption } from "../../../config/custom-encrypt";
import moment from "moment";
import { WireRequestService } from "../wire-requests/wire-requests.service";
import * as CryptoJS from 'crypto-js';
import { StorageServiceAAA } from "../../helpers/aaa-storage.service";

@Injectable({providedIn: 'root'})
export class DashBoardService {
	private hierarchyList = URLS.hierarchyList;
	private clientHoldingMargin = URLS.clientHoldingMargin;
	private dashboarddetail = URLS.dashboarddetail;
	private aumdetail = URLS.aumdetail;
	private sipBook = URLS.sipBook;
	private insuranceSumm = URLS.insuranceSummary;
	private clientDetail = URLS.clientDetail;
	private brokerageDetails = URLS.brokerageDetails;
	private iglcScoreDetails = URLS.iglcScore;
	private flyhigh = URLS.flyhighData;
	private quickLink = URLS.getQuickLink;
	private addLink = URLS.addQuickLink;
	private crossSellDetails = URLS.crossSellDetails;
	private mfDashboard = URLS.mfDashboard;
	private equityDashboard = URLS.equityDashboard;
	private overallDashboard = URLS.overallDashboard;
	private defaultDashboard = URLS.defaultDashboard;
	private productWiseClient = URLS.productWiseClient;

	private partnerPoints = URLS.partnerPoints;
    private ipoList = URLS.ipoList;
	private clientCount = URLS.clientCount;
    private getClientHoldingAbove25L = URLS.getClientHoldingAbove25L
    private BusinessOppsFao = URLS.BusinessOppsFao
    private clientwithoutSip = URLS.clientWithoutSip
    private clientNotTraded = URLS.clientNotTraded
    private clientTobeDormant = URLS.clientTobeDormant
    private getBrokeragePerform = URLS.getBrokeragePerformance
    private ncdMfHolding = URLS.getNcdMfDebtHolding
    private dayWiseBrokerageGraph = URLS.dayWiseBrokerageGraph
    private dashBoardCount = URLS.dashBoardCount
	private IncentivesPremiaRMs = URLS.incentivesPremiaRMs
  
  
	private oneUploginThrowApp = URLS.oneUploginThrowApp;
	private ipoClientList = URLS.ipoClientList;	
	private peerPoints = URLS.peerPoints;
	private ClientNotInvestedMF = URLS.ClientNotInMF
	private equityMfLeads = URLS.equityMfLeads
	private bDayToday = URLS.bDayToday
	private p1p2p3Clients = URLS.p1p2p3Clients
	private leadStats = URLS.leadStats
	private fixedIncomeLeads = URLS.fixedIncomeLeads
	private PmsAifLeads = URLS.PmsAifLeads
	private GetRMHierarchyNew = URLS.GetRMHierarchyNew;
	private GetClientCodes = URLS.GetClientCodes;
	private wireMappedCode = URLS.wireMappedCode;
	private removeClientAccess = URLS.removeClientAccess;
	private KPIDashBoardBDM = URLS.kpiDashboardBDM;
	private FatchCustomMappingurl = URLS.FatchCustomMapping;
	private addDeleteCustomMapping = URLS.AddDeleteCustomMapping;
	private ipAdressData: any = environment['ipAdress'];
	private trackAssetExternal = URLS.trackAssetExternal;
	private offlineDetails = URLS.offlineDetailsCapture;
	private SaveClientOfflineDetails = URLS.SaveClientOfflineDetails
	private encryptWithCryptoJSKey = '';
	private dashboardSummaryDetails = URLS.getDashboardSummary;
	private getNotInvestedinSIPs = URLS.getNotInvestedinSIPs;
	env:any;
	offlineAuth: any;
	private httpBackend: HttpClient; 
	constructor(private httpClient: HttpClient,
		private nativeHttp: HTTP,
		private platform: Platform,
		private commonService: CommonService,
		private ciphetText: CustomEncryption,private wireReqService: WireRequestService,private storage: StorageServiceAAA,private handler: HttpBackend) {
			this.httpBackend = new HttpClient(this.handler);
			this.storage.get('envSettings').then((envSettings) => {
				const key = envSettings?.encryptWithCryptoJSkey;
				if (key && key !== 'encryptWithCryptoJSkey') {
					this.encryptWithCryptoJSKey = key;
				}
			});
			this.fetchRuntimeEncryptionKey();
			this.setLoginDashboardRefreshTimeout();
	}

	private fetchRuntimeEncryptionKey(): void {
		const url = this.commonService.isApp()
            ? environment.apiProxyBaseUrl + '/api/public/runtime-config'
            : '/api/public/runtime-config';
        this.httpBackend.get<any>(url).subscribe({
			next: (res) => {
				const key = res?.encryptWithCryptoJSkey;
				if (key && key !== 'encryptWithCryptoJSkey') {
					this.encryptWithCryptoJSKey = key;
					this.commonService.set('encryptWithCryptoJSkey', key);
					if (typeof window !== 'undefined') {
						window.localStorage?.setItem('encryptWithCryptoJSkey', key);
					}
				}
			}
		});
	}

	private setLoginDashboardRefreshTimeout(): void {
		const url = this.commonService.isApp()
			? environment.apiProxyBaseUrl + '/api/public/runtime-config'
			: '/api/public/runtime-config';

		this.httpBackend.get<any>(url).subscribe({
			next: (res) => {
				const parsedRefreshTimeout = Number(res?.loginDashboardRefreshTimeout);

				if (Number.isFinite(parsedRefreshTimeout) && parsedRefreshTimeout > 0) {
					this.commonService.set('loginDashboardRefreshTimeout', String(parsedRefreshTimeout));
				}
			}
		});
	}

	private resolveEncryptWithCryptoJSKey(): string {
		const keyName = 'encryptWithCryptoJSkey';

		if (this.encryptWithCryptoJSKey) {
			return this.encryptWithCryptoJSKey;
		}

		const commonServiceValue = this.commonService.get(keyName);
		if (commonServiceValue && commonServiceValue !== keyName) {
			return commonServiceValue;
		}

		if (typeof window !== 'undefined') {
			const localStorageValue = window.localStorage?.getItem(keyName);
			if (localStorageValue && localStorageValue !== keyName) {
				return localStorageValue;
			}

			const envSettingsRaw = window.localStorage?.getItem('envSettings');
			if (envSettingsRaw) {
				try {
					const envSettings = JSON.parse(envSettingsRaw);
					const envKey = envSettings?.[keyName];
					if (envKey && envKey !== keyName) {
						return envKey;
					}
				} catch {
				}
			}
		}

		return '';
	}

	getIPAdress(){
		let reqHead = {
			'Ocp-Apim-Subscription-Key': "AAA_OCP"
		};
		// return this.httpClient.get(this.ipAdressData,{ headers: headers });
		const config = {
				url: this.ipAdressData,
				subKey:'AAA_OCP'
			} 
			return this.sendReqTOServerGet({}, config, reqHead) ;
	}

	fetchGetClientCodes(userType: any, userID: any, token: any, searchText: any): Observable<any> {
		const userId = this.commonService.get('userId1');
		const jwtToken = this.commonService.get('jwt_token');
		const url = `${this.GetClientCodes.url}/${userId}/${searchText}/${userType}`;

		const params = {};
		const reqHead = {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${jwtToken}`,
			'appID': this.commonService.get('appID') || '',
			'Ocp-Apim-Subscription-Key': 'AAA_OCP'
		};
		const config = {
			url,
			subKey: 'AAA_OCP',
			method: 'GET'
		};

		return this.httpClient.post('/api/secure/common-all-service-get', {params, config, reqHead})
	}

	sendReqTOServer(params:any,config:any,reqHead:any): Observable<{}>{ 
			return this.httpClient.post('/api/secure/dashboard-service', {
				params,
				config,
				reqHead
			})
		}

		sendReqTOServerMaping(params:any,config:any,reqHead:any): Observable<{}>{ 
			return this.httpClient.post('/api/secure/dashboard-service-mapping', {
				params,
				config,
				reqHead
			})
		}


		

	sendReqTOServerGet(params:any,config:any,reqHead:any): Observable<{}>{ 
		return this.httpClient.post('/api/secure/common-all-service-get', {
			params,
			config,
			reqHead
		})
	}

	public deleteClientAccess(data: any, cookievalue: any): Observable<{}> {
		let params = {
			"body": {data},
			  "head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "1.0.4.0",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			}
		}

		let reqHead = {
			appID: this.commonService.get('appID') || '',
			'Ocp-Apim-Subscription-Key' : "",
			'token': cookievalue
		}
		const config = {
			url: this.removeClientAccess.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP'
		} 
		return this.sendReqTOServer(params, config,reqHead);

	}

	public fetchWireMappedCode(flag: any, cookievalue: any, userId: any, env:any): Observable<{}> {
		if(this.env == undefined || this.env == null){
            this.env = env
        }
		let params = {
			"body": {
				"loginid": userId,
				"Flag" : flag
			},
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "1.0.4.0",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			}
		}
		

			let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'token': cookievalue
		}
		const config = {
			url: this.wireMappedCode.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP'
		} 
		return this.sendReqTOServer(params, config,reqHead);



	}


	// left for changes
	fetchRMHierarchyNew(userType: any, userID: any, token: any, searchText: any): Observable<any> {
		var UserId = this.commonService.get('userId1');
		var UserType = this.commonService.get('userType');
		var Token = this.commonService.get('jwt_token');

		let reqHead = {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${Token}`,
				'Ocp-Apim-Subscription-Key': "AAA_OCP",
				'Access-Control-Allow-Origin': ""
			}
		const url = `${this.GetRMHierarchyNew.url}/${UserId}/${searchText}/${UserType}`;

			const config = {
				url: url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 
			return this.sendReqTOServerGet({}, config, reqHead) ;
	}

	public getPartnerDetail(cookievalue: any, partnerID: any): Observable<{}> {
		let params = {
			"body": {
				"PartnerCode": partnerID,
				"Tops": "0"
			},
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			}
		}

		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'token': cookievalue
		}
		const config = {
			url: this.partnerPoints.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP'
		} 
		return this.sendReqTOServer(params, config,reqHead);

	}

	getIPOList(cookievalue: any) {
		let params = {}

		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			withCredentials: 'true',
			'token' : cookievalue
		}
		const config = {
			url: this.ipoList.url,
			subKey:'ipo'
		} 
		return this.sendReqTOServer(params, config,reqHead);
	}

	public getOneUpIPOLink(cookievalue: string, clientCode: string, issueCode: string): Observable<{}> {
		let code  = clientCode.toUpperCase();
		let appSource;
		if (this.platform.is('android')) {
			appSource = 12;
		} else if (this.platform.is('mobileweb') || this.platform.is('desktop')) {
			appSource = 13;
		} else if (this.platform.is('ios')) {
			appSource = 11;
		}
		let dataToSend = {
			"requesterCode": this.encryptWithCryptoJS(code),
			"clientCode": this.encryptWithCryptoJS(code),
			"appSource": appSource,
			"clientType": 6,
			"Page": issueCode
		}

		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			withCredentials: 'true',
			'token' : cookievalue,
			'Authorization': ''
		}
		const config = {
			url: this.oneUploginThrowApp.url,
			// Key: 'ipo',
			subKey:'ipo',
			Authorization:"Authorization_Ipo_Offline"
		} 
		return this.sendReqTOServer(dataToSend, config,reqHead);
	}

	public getClientCount(cookievalue: any, data: any) {
		let params = { "head": { "RequestCode": "CVUpdateLead01", "Key": "", "AppName": environment.boAppName, "AppVer": "01", "OsName": "Android",
		"userType": this.commonService.get('userType') }, "body": data }

		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
		}
		const config = {
			url: this.clientCount.url,
			Key: 'VerifyRequestApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead);
	}

	public applyClientNonClient(cookievalue: string, dataToSend: any): Observable<{}> {	
		dataToSend.requesterCode = this.encryptWithCryptoJS(dataToSend.requesterCode);
		dataToSend.clientCode = this.encryptWithCryptoJS(dataToSend.clientCode);	 	
		
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
			Authorization:''
		}
		const config = {
			url: this.oneUploginThrowApp.url,
			subKey:'ipo',
			Authorization:"Authorization_Ipo_Offline"
		} 
		return this.sendReqTOServer(dataToSend, config,reqHead);
	}

	public getInterestedClientList(cookievalue: string, data:any): Observable<{}> {
		let params = { "head": { "RequestCode": "CVUpdateLead01", "Key": "", "AppName": environment.boAppName, "AppVer": "01", "OsName": "Android",
		"userType": this.commonService.get('userType') }, "body": data }
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
		}
		const config = {
			url: this.ipoClientList.url,
			Key: 'VerifyRequestApi',
			subKey:'AAA_OCP',
		}
		return this.sendReqTOServer(params, config,reqHead);
	}

	public getClientHolding25(cookievalue: any, passObj: any): Observable<{}> {
		let params = {
			"body": passObj,
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": this.getClientHoldingAbove25L.appName,
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			}
		}
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
		}
		const config = {
			url: this.getClientHoldingAbove25L.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead);
	}

	public businessFao(cookievalue: any, userId: any): Observable<{}> {
		let params = {
			"head": {
				"requestcode": "APIBO52UCVDWFY",
				"Key": "",
				"appver": "01",
				"appname": this.BusinessOppsFao.appName,
				"osname": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"PartnerCode": userId,
			}
		}

		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
		}
		const config = {
			url: this.getClientHoldingAbove25L.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead);
	}

	public kpiDashboardBDM(cookievalue: any, userId: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				 "loginid": userId
			}
		}
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
		}
		const config = {
			url: this.KPIDashBoardBDM.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead);
	}

	public clientMfNotTraded(cookievalue: any, passObj: any): Observable<{}> {
		let params = {
			"body": passObj,
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": this.clientwithoutSip.appName,
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			}
		}

		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
		}
		const config = {
			url: this.clientwithoutSip.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead);
	}

	public incentivesPremiaRMs(cookievalue: any, userId: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				 "login": userId
			}
		}
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
		}
		const config = {
			url: this.IncentivesPremiaRMs.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead);

	}

	public clientsNotTraded(cookievalue: any, passObj: any): Observable<{}> {
		let params = {
			"head": {
				"requestcode": "CVUpdateLead01",
				"Key": "",
				"appver": "01",
				"appname": this.clientNotTraded.appName,
				"osname": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": passObj
		}

		
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
		}
		const config = {
			url: this.clientNotTraded.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getClientTobeDormant(cookievalue: any, passObj: any): Observable<{}> {
		let params = {
			"head": {
				"requestcode": "CVUpdateLead01",
				"Key": "",
				"appver": "01",
				"appname": this.clientTobeDormant.appName,
				"osname": "Android",
				"userType": this.commonService.get('userType')
			},
			"body":passObj
		}

		let obj: any = {
			'Ocp-Apim-Subscription-Key' :"",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
			
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
		}
		const config = {
			url: this.clientTobeDormant.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public clientWireDashboardReport(token: string, body: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppVer": "01",
				"AppName": 'AAA',
				"OsName": this.commonService.getPlatform(),
				"userType": this.commonService.get('userType')
			},
			"body": body
		}
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : token,
		}
		const config = {
			url: URLS.dashboardReport.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getBusinessCount(cookievalue: any, userId: any): Observable<{}> {
		let params = {
		  "head": {
			"RequestCode": "CVUpdateLead01",
			"Key": "",
			"AppName": this.dashBoardCount.appName,
			"AppVer": "01",
			"OsName": "Android",
			"userType": this.commonService.get('userType')
		  },
		  "body": {
			"LoginID": userId
		  }
		}
		  
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
		}
		const config = {
			url: this.dashBoardCount.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)

	  }


	public getBrokMtdEquity(cookievalue: any, userId: any,fromDateChange?: any,toDateChange?: any, data? : any): Observable<{}> {
		const params = {
			cookievalue: cookievalue, userId: userId, fromDateChange: fromDateChange, toDateChange: toDateChange, data: data,
			'appID': this.commonService.get('appID') || '',url: this.getBrokeragePerform.url
		}
		return this.httpClient.post('/api/secure/getBrokMtdEquity', {
				params
		})
	}

	public getNcdMfHolding(cookievalue: any, passObj: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": this.ncdMfHolding.appName,
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": passObj
		}

			let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
		}
		const config = {
			url: this.ncdMfHolding.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getBrokChart(cookievalue: any, passObj: any): Observable<{}> {
		let params = {
			"head": {
				"requestcode": "APIBO52UCVDWFY",
				"Key": "",
				"appver": "01",
				"appname": this.dayWiseBrokerageGraph.appName,
				"osname": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": passObj
		}

					let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': this.commonService.get('brokerageToken')
		}
		const config = {
			url: this.dayWiseBrokerageGraph.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getPeerPoints(cookievalue: any, passObj: any): Observable<{}> {
		let params = {
			"body": passObj,
			"head": {
			  "RequestCode": "CVUpdateLead01",
			  "Key": "",
			  "AppName": this.peerPoints.appName,
			  "AppVer": "01",
			  "OsName": "Android",
			  "userType": this.commonService.get('userType')
			}
		  }

		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': cookievalue
		}
		const config = {
			url: this.peerPoints.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getClientInvestedMF(cookievalue: any, passObj: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": this.ClientNotInvestedMF.appName,
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": passObj
		}
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			token: cookievalue

		}
		const config = {
			url: this.ClientNotInvestedMF.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getEquityLeads(cookievalue: any, passObj: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "FetchClientDebtMFAUM",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "1.0.4.0",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": 
				passObj
		}
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			token: cookievalue
		}
		const config = {
			url: this.equityMfLeads.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getListOfClientsBdays(cookievalue: any, passObj: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body":
				passObj
		}
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue
		}
		const config = {
			url: this.bDayToday.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getP1P2P3ClientList(cookievalue: any, passObj: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key":"",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body":
				passObj
		}
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue
		}
		const config = {
			url: this.p1p2p3Clients.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getFixedIncomeLeads(cookievalue: any, passObj: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "FetchClientDebtMFAUM",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "1.0.4.0",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": 
				passObj
			}
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token' : cookievalue,
			"Key": "Verify_Guest_And_ExtendedApi",
		}
		const config = {
			url: this.fixedIncomeLeads.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getLeadStatsChartData(cookievalue: any, rmCode: any): Observable<{}> {
		let params = {
			"Parameters": {
				"RM_Code": rmCode
			}
		};
		
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'Authorization' : 'CRM-oauthtoken ' + cookievalue
		}
		const config = {
			url: this.leadStats.url,
			Key: '',
			subKey:'iiflcrm_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}
	
	public getPmsLeads(cookievalue: any, passObj: any): Observable<{}> {


		const params = {
			cookievalue: cookievalue, passObj: passObj,userType: this.commonService.get('userType'),
			'appID': this.commonService.get('appID') || '',
			url: this.PmsAifLeads.url
		}
		return this.httpClient.post('/api/secure/getPmsLeads', {
				params
		})
	}




	// DashBoard-revamp Services

	public getClientHoldingMargin(params: any): Observable<{}> {
		
		// let params = {
		// 	"head": {
		// 		"requestCode": "IIFLMarRQGetClientHoldingAndMargin", 
		// 		"Key": "TTParams_Key", 
		// 		"appVer": "1.0.22.0", 
		// 		"appName": "IIFLMarkets", 
		// 		"osName": "Android",
		// 		"userType": this.commonService.get('userType')
		// 	}, "body": passobj
		// }

		// let reqHead = {
		// 	'Ocp-Apim-Subscription-Key' : 'TT_OCP',
		// 	'appID': this.commonService.get('appID') || '',
		// 	'token' :  '.ASPXAUTH=' + this.commonService.get('JwtToken'),
        //      UserID: 'headersParams_optionalHeaders_UserId',
        //     Password: 'headersParams_optionalHeaders_Password'
		// }
		// const config = {
		// 	url: this.clientHoldingMargin.url,
		// 	Key: 'TTParams_Key',
		// 	subKey:'TT_OCP',
		// 	UserID: 'headersParams_optionalHeaders_UserId',
        //     Password: 'headersParams_optionalHeaders_Password'
		// } 
		// return this.sendReqTOServer(params, config,reqHead)
		let token = this.commonService.get('JwtToken')
		let appId =  this.commonService.get('appID')
		let userType =  this.commonService.get('userType')
		let LoginId = this.commonService.get('userId1')
		return this.httpClient.post('/api/secure/getClientHoldingMargin', 
			{params,token,appId,userType,LoginId})
	}

	public dashBoardDetail(cookievalue: any, clientID: any): Observable<{}> {
		const checkSumKey = this.ciphetText.generateCheckSumKey()
		const checkSumString = clientID + "_" + checkSumKey + "_" + moment(new Date()).format('DDMMYYYY')
		const ClientCode = this.ciphetText.createChecksum(clientID,checkSumKey)
		let params = {
			head: {
				RequestCode: "CVUpdateLead01",
				Key: "",
				AppName: this.dashboarddetail.appName,
				AppVer: "1.0.4.0",
				OsName: "Android",
				CheckSum: checkSumString,
				CheckSumKey: checkSumKey,
			},
			body: {
				Loginid: ClientCode

			}
		}
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': this.commonService.get('brokerageToken')
		}
		const config = {
			url: this.dashboarddetail.url,
			Key: 'VerifyRequestApi',
			subKey:'AAA_OCP',
			isCheckSum: true,
			checkSumName:''
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getHierarchyList(cookievalue: any, clientID: any): Observable<{}> {
		let params = {
			head: {
				RequestCode: "CVUpdateLead01",
				Key: "",
				AppName: this.hierarchyList.appName,
				AppVer: "1.0.4.0",
				OsName: "Android",
			},
			body: {
				Loginid: clientID
			}
		}
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': this.commonService.get('brokerageToken')
		}
		const config = {
			url: this.hierarchyList.url,
			Key: 'VerifyRequestApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getAUMDetail(cookievalue: any, data: any): Observable<{}> {
		let checkSumKey = this.ciphetText.generateCheckSumKey();
		let checkSumString = `${this.commonService.get('userId1')}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
		const loginID = this.ciphetText.createChecksum(this.commonService.get('userId1') ,checkSumKey);
		let params = {
			head: {
				RequestCode: "CVUpdateLead01",
				Key: "",
				AppName: this.aumdetail.appName,
				AppVer: "1.0.4.0",
				OsName: "Android",
				CheckSum: checkSumString,
				CheckSumKey: checkSumKey,
				
			},
			body: {
				Role: this.commonService.get('userChannel'),
				Loginid: loginID,
				PartnerCode: data.PartnerID,
				DataType: this.commonService.get('toggleSwitch')
			}
		}

		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': cookievalue
		}
		const config = {
			url: this.aumdetail.url,
			Key: 'VerifyRequestApi',
			subKey:'AAA_OCP',
			isCheckSum: true,
			checkSumName:''
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getSIPBookDetail(cookievalue: any, clientID: any): Observable<{}> {
		let params = {
			head: {
				RequestCode: "CVUpdateLead01",
				Key: "",
				AppName: this.sipBook.appName,
				AppVer: "1.0.4.0",
				OsName: "Android",
			},
			body: {
				Loginid: clientID

			}
		}
				let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': cookievalue
		}
		const config = {
			url: this.sipBook.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getAFYPDetail(cookievalue: any, clientID: any): Observable<{}> {
		// { "head": { "RequestCode": "GetAAAInsuranceSummary", "Key": this.env.verifyGuestandExtendedApi.Key, "AppName": "AAA", "AppVer": "1.0.4.0", "OsName": "Android" }, "body": { "RMCode": "C1011" } }
		let params = {
			head: {
				RequestCode: "GetAAAInsuranceSummary",
				Key: "",
				AppName: this.insuranceSumm.appName,
				AppVer: "1.0.4.0",
				OsName: "Android",
			},
			body: {
				RMCode: clientID,
				PartnerCode: this.commonService.get('empCode') ? this.commonService.get('empCode') : this.commonService.get('userId1'),
				DataType: this.commonService.get('toggleSwitch'),
				Role: this.commonService.get('userChannel')
			}
		}
			let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': cookievalue
		}
		const config = {
			url: this.insuranceSumm.url,
			Key: 'VerifyRequestApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getTotalClientsDetail(cookievalue: any, clientID: any): Observable<{}> {
		let params = {
			head: {
				RequestCode: "CVUpdateLead01",
				Key: "",
				AppName: this.clientDetail.appName,
				AppVer: "1.0.4.0",
				OsName: "Android",
			},
			body: {
				Loginid: clientID

			}
		}
			let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': cookievalue
		}
		const config = {
			url: this.insuranceSumm.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getBrokerageDetails(cookievalue: any, data: any): Observable<{}> {
		let params = {
			head: {
				RequestCode: "CVUpdateLead01",
				Key: "",
				AppName: this.brokerageDetails.appName,
				AppVer: "1.0.4.0",
				OsName: "Android",
			},
			body: data
		}
					let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': this.commonService.get('brokerageToken')
		}
		const config = {
			url: this.brokerageDetails.url,
			Key: 'VerifyRequestApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}
	public getIglcScoredetails(cookievalue: any, PartnerCode: any): Observable<{}> {
		let params = {
			head: {
				"RequestCode": "CVUpdateLead01",
     			"Key": "",
     			"AppName": "AAA",
     			"AppVer": "01",
     			"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			body: {
				PartnerCode: PartnerCode
			}
		}
			let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': cookievalue
		}
		const config = {
			url: this.iglcScoreDetails.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getFlyHighdetails(token: any,loginID: any,userType: any): Observable<{}> {
		let params: any = {
			head: {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			body: {
				"loginid": loginID,
				"UserType":userType
			}
		}
			let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': token
		}
		const config = {
			url: this.flyhigh.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	public getQuickLinks(token: any, body: any): Observable<{}> {
		let params: any = {
			head: {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android"
			},
			body
		}

		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': token
		}
		const config = {
			url: this.quickLink.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	addQuickLinks(token: any, body: any): Observable<{}> {
		let params: any = {
			head: {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android"
			},
			body
		}
		
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': token
		}
		const config = {
			url: this.addLink.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}
	
	getCrossSellDetails(token: any, body: any): Observable<{}> {
		let params: any = {
			head: {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android"
			},
			body
		}
		
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': token
		}
		const config = {
			url: this.crossSellDetails.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	getMFDashboard(token: any, body: any): Observable<{}> {
		let params: any = {
			head: {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android"
			},
			body
		}
		let reqHead = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || '',
			'token': token
		}
		const config = {
			url: this.mfDashboard.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,reqHead)
	}

	getEquityDashboard(token: any, body: any): Observable<{}> {
		let params: any = body
		let obj: any = {
			'Ocp-Apim-Subscription-Key': "",
			'appID': this.commonService.get('appID') || ''
		};
		if (token) {
			obj['token'] = token;
		}
		const config = {
			url: this.equityDashboard.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.httpClient.post('/api/secure/get-dashboard-data', {params, obj,config });
	}

	getOverallDashboard(token: any, body: any): Observable<{}> {
		let params: any = body
		let obj: any = {
			'Ocp-Apim-Subscription-Key': "",
			'appID': this.commonService.get('appID') || ''
		};
		if (token) {
			obj['token'] = token;
		}
		const config = {
			url: this.overallDashboard.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.httpClient.post('/api/secure/get-dashboard-data', {params, obj,config });
	}

	getDefaultDashboard(token: any, body: any): Observable<{}> {
		let params: any = {
			head: {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android"
			},
			body
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key': "",
			'appID': this.commonService.get('appID') || ''
		};
		if (token) {
			obj['token'] = token;
		}

		const config = {
			url: this.defaultDashboard.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	

	getProductWiseClient(token: any, body: any): Observable<{}> {
		let params: any = {
			head: {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "1.0.4.0",
				"OsName": "Android"
			},
			body
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key': "",
			'appID': this.commonService.get('appID') || ''
		};
		if (token) {
			obj['token'] = token;
		}
		const config = {
			url: this.productWiseClient.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
		} 
		return this.sendReqTOServer(params, config,obj)

	}



	
	public FatchCustomMapping(cookievalue: any, CheckSum: any, SubMasterfancode:any, type:any): Observable<{}> {
		let params = {
			"body": {
				"LoginId":this.commonService.get('userId1'),
     			"SubMasterfancode":SubMasterfancode,
     			"Type":type
			},
			"head": {
				"RequestCode": "FatchCustomMapping",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"CheckSum":CheckSum,
    			"CheckSumKey":""
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : ""
		};		
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.FatchCustomMappingurl.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
			isCheckSum: true,
			checkSumName:'globalChecksumKey'
		} 
		return this.sendReqTOServerMaping(params, config,obj)
	}
	public AddUpdateCustomMapping(cookievalue: any, CheckSum: any, body:any): Observable<{}> {
		let params = {
			"body":body,
			"head": {
				"RequestCode": "AddDeleteCustomMapping",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"CheckSum":CheckSum,
    			"CheckSumKey":""
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : ""
		};		
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.addDeleteCustomMapping.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
			isCheckSum: true,
			checkSumName:'globalChecksumKey'
		} 
		return this.sendReqTOServerMaping(params, config,obj)
	}




	public fetchTrackAssetExternal(cookievalue:any,userId1:any){
		let obj: any = {
			'Authorization' : 'Bearer '+cookievalue,
			'Ocp-Apim-Subscription-Key' : "",
			'X-IIFL-TOKEN': this.ciphetText.aesEncrypt(this.commonService.get('jwt_token')),
		    'X-IIFL-COOKIE':  this.ciphetText.aesEncrypt(this.commonService.get('brokerageToken'))
		};
		let config={
			url: this.trackAssetExternal.url+userId1,
			subKey:'investEdge2_OCP',
			checkSumName:'globalChecksumKey'
		}
		// For Android app use full URL (httpBackend resolves relative paths to localhost)
		// For web use relative path (works fine with interceptors)
		const url = this.commonService.isApp()
			? environment.apiProxyBaseUrl + '/api/secure/invest-server'
			: '/api/secure/invest-server';
		return this.httpBackend.post(url,{obj,config})
}
 investEdgeLink(){
	return this.wireReqService.getinvestcurrentTime()	
}
encryptWithCryptoJS(plainText: string): string {
	const resolvedKey = this.resolveEncryptWithCryptoJSKey();
	if (!resolvedKey) {
		throw new Error('encryptWithCryptoJSkey is missing in runtime configuration');
	}
	const Key = CryptoJS.enc.Utf8.parse(resolvedKey);
	const iv1 = CryptoJS.enc.Utf8.parse("0000000000000000");
	const encrypted = CryptoJS.AES.encrypt(plainText, Key, {
	
	iv: iv1,
	mode: CryptoJS.mode.ECB,
	padding: CryptoJS.pad.Pkcs7
	});
	//let res = encrypted.ciphertext.toString(CryptoJS.enc.Hex);
	return encrypted.toString();
}

public clientWireDashboardReport1(body:any,cookievalue:any,checkSumValue: any, checkSumKey: any): Observable<{}> {
	let params = {
		"head": {
			"RequestCode": "ClientWireDashboardreportV1",
			"Key": "",
			"AppVer": "01",
			"AppName": "AAA",
			"OsName": "WEB",
			"CheckSumKey": checkSumKey,
			"CheckSum": checkSumValue
		},
		"body": body
	}
	let obj: any = {
		'Ocp-Apim-Subscription-Key' : "",
		'appID': this.commonService.get('appID') || ''
	};
	if (cookievalue) {
		obj['token'] = cookievalue;
	}
	const config = {
			url: URLS.dashboardReport1.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
			isCheckSum: true,
			checkSumName:''
		} 
		return this.sendReqTOServer(params, config,obj)
}
	getOfflineClientCapture(token:any): Observable<{}> {
		let checkSumKey = this.ciphetText.generateCheckSumKey();
          let stringValue = `${this.commonService.get('userId1')}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
          const loginID = this.ciphetText.createChecksum(this.commonService.get('userId1') ,checkSumKey);
		let params: any = {
			head: {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
        		"AppName": "AAA",
        		"AppVer": "01",
        		"OsName": "Android",
        		"CheckSum": stringValue,
        		"CheckSumKey": checkSumKey
			},
			body:{
				"PartnerCode": loginID
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key': ""
		}
			obj['token'] = token;
		const config = {
			url: this.offlineDetails.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
			isCheckSum: true,
			checkSumName:''
		} 
		return this.sendReqTOServer(params, config,obj)
	}
	getSaveClientOfflineDetails(token:any,passObj:any): Observable<{}> {
		let data: any = [];
		let checkSumKey = this.ciphetText.generateCheckSumKey();
		  	let stringValue = `${this.commonService.get('userId1')}_${passObj[0].PAN}_${passObj[0].Mobile}_${passObj[0].Email}_${passObj[0].Name}_${passObj[0].Address}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
          	const loginID = this.ciphetText.createChecksum(this.commonService.get('userId1') ,checkSumKey);
		  for(let data of passObj){
			
			const data1 = {
							"PartnerCode": loginID,
							"PAN":data.PAN,
							"Mobile":data.Mobile,
							"Email":data.Email,
							"Name":data.Name,
							"Address":data.Address
					}

			data.push(data1);
		  }
		  const params={
			head: {
							"RequestCode": "CVUpdateLead01",
							"Key": "",
							"AppName": "AAA",
							"AppVer": "01",
							"OsName": "Android",
							"CheckSum": stringValue,
							"CheckSumKey": checkSumKey
						},
						body:data
		  }
		let obj: any = {
			'Ocp-Apim-Subscription-Key': ""
		}
		obj['token'] = token;
		const config = {
			url: this.SaveClientOfflineDetails.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP',
			isCheckSum: true,
			checkSumName:''
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	private resolveLoginIdForMfApis(): string {
		const primaryLoginId = this.commonService.get('userId1');
		const secondaryLoginId = this.commonService.get('userID');
		const fallbackLoginId = this.commonService.get('LoginID') || this.commonService.get('LoginId');
		return (primaryLoginId || secondaryLoginId || fallbackLoginId || '').toString().trim().toLowerCase();
	}

	mfDashboardSummary(bodyObj: any): Observable<any> {
		const loginId = this.resolveLoginIdForMfApis();
		const config = {
			url: this.dashboardSummaryDetails.url,
		}
		const params = {
			body: {
				LoginID: loginId,
				Type: bodyObj.DataType,
			}
		}
		const reqHead = {
			token: this.commonService.get('jwt_token'),
		}
		return this.httpClient.post('/api/secure/mf-data-service', { config, params, reqHead });
	}

	notInvestedinSIPs(passObj:any): Observable<any> {
		const loginId = this.resolveLoginIdForMfApis();
		// console.log("notInvestedinSIPs",passObj)
		const config = {
			url: this.getNotInvestedinSIPs.url,
		}

		const params = {
			body: {
				LoginID: loginId,
				"Type": this.commonService.get('toggleSwitch') === "Self" ? "Individual" : "Hierarchy",
				"PageNo": passObj.PageNo,
				"SortBy": passObj.SortBy,
				"SortOrder": passObj.SortOrder,
				"SearchBy": passObj.SearchBy,
				"SearchText": passObj.SearchText,
			}
		}
		const reqHead = {
			token: this.commonService.get('jwt_token'),
		}
		return this.httpClient.post('/api/secure/mf-data-service', { config, params, reqHead });
	}
}